module.exports = require("@material-ui/icons/Edit");;